import { ref } from "vue";

// Module-level singleton — the single <ConfirmDialog /> mounted in App.vue
// serves every caller. Usage:
//   const { confirm } = useConfirm();
//   if (await confirm({ message: "...", danger: true })) { ... }
const visible = ref(false);
const options = ref({});
let resolver  = null;

export function useConfirm() {
  function confirm(opts = {}) {
    options.value = {
      title:       opts.title       || "تأكيد",
      message:     opts.message     || "",
      confirmText: opts.confirmText || "تأكيد",
      cancelText:  opts.cancelText  || "إلغاء",
      danger:      !!opts.danger,
      icon:        opts.icon        || null, // FA class, e.g. "fa fa-thumbs-up"
    };
    visible.value = true;
    return new Promise((resolve) => {
      // A confirm opened over a pending one cancels the older promise
      if (resolver) resolver(false);
      resolver = resolve;
    });
  }

  function respond(answer) {
    visible.value = false;
    if (resolver) {
      resolver(answer);
      resolver = null;
    }
  }

  return { visible, options, confirm, respond };
}
